import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../Link';

const space = '10px';

export const StyledFooter = styled.footer`
  background-color: ${themeGet('colors.main-text')};
  padding: calc(${space} * 4) 0 calc(${space} * 14);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: calc(${space} * 4) 0;
  }

  a,
  button,
  p,
  li {
    color: ${themeGet('colors.white')};
  }
`;

export const Logo = styled.img`
  width: 100%;
  max-width: 126px;
  height: 100%;
  max-height: 51px;
`;

export const TopRow = styled.div`
  margin-bottom: calc(${space} * 5);
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1015px) {
    flex-direction: row;
  }
`;

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: calc(${space} * 5);

  @media only screen and (min-width: 1015px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const LeftContainer = styled.div`
  @media only screen and (min-width: 1015px) {
    width: 35%;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: -${space};
  a {
    font-size: 14px;
    font-weight: ${themeGet('fontWeights.normal')};
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    margin: 0.625rem 0;

    &:focus,
    &:hover {
      opacity: 0.8;
      color: ${themeGet('colors.white')};
    }

    span {
      padding-bottom: 0;
      border-bottom: none;
      font-weight: inherit;
    }
  }

  @media only screen and (min-width: 691px) {
    flex-wrap: nowrap;
  }

  @media only screen and (min-width: 1015px) {
    width: 65%;
    margin-left: auto;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 50%;
  padding: 0 ${space};

  &:first-child {
    order: 0;
  }

  &:nth-child(2) {
    order: 2;
  }

  &:nth-child(3) {
    order: 1;
  }

  &:last-child {
    order: 3;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* This fixes IE flex calc bug */
    flex: 0 1 45%;
  }

  @media only screen and (min-width: 691px) {
    flex: 0 1 25%;

    &:first-child {
      order: 0;
    }

    &:nth-child(2) {
      order: 1;
    }

    &:nth-child(3) {
      order: 2;
    }

    &:last-child {
      order: 3;
    }
  }

  @media only screen and (min-width: 1015px) {
    flex: 1 1 100%;
  }

  a {
    display: flex;
    justify-content: flex-start;

    &:hover {
      & > svg {
        color: ${themeGet('colors.white', 'white')};
      }

      span {
        border-bottom: none;
      }
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  flex-direction: row;
  margin: 2rem -13px;

  a {
    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }

  svg {
    margin: 0 13px;
    height: 100%;
    width: 100%;
    max-height: 24px;
    max-width: 24px;
  }
`;

export const AffiliateLinks = styled.div`
  display: flex;
  flex-direction: row;
  margin: 2rem -13px;

  a {
    &:focus,
    &:hover {
      opacity: 0.8;
      color: ${themeGet('colors.white')};
    }
  }

  img {
    margin: 0 13px;
    height: 100%;
    width: 100%;
    max-height: 75px;
    max-width: 75px;
  }

  @media only screen and (min-width: 1015px) {
    margin: 2rem -13px 0;
  }
`;

export const StyledLink = styled(Link)`
  span {
    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      font-weight: ${themeGet('fontWeights.normal')};
    }
  }
`;

export const CookieButton = styled.button`
  font-size: 0.825rem;
  line-height: 150%;
  text-align: left;
`;
